<template>
  <div class="help">
    <h2>Help</h2>
    <div class="scores">
      <strong>Power ups</strong>
      <p>
        On every 7th level or getting a c-c-combo (clearing the field with one combo) will reward you with one random power up
        <br>

        <ul class="power-up-list">
          <li>
            <div class="wrapper">
              <div class="icon">
                <i class="fa fa-bomb"></i>
              </div>
              <div class="text">
                <strong>Bomb</strong>
                <p>Kill one tile and hurt the ones around it.</p>
              </div>
            </div>
          </li>
          <li>
            <div class="wrapper">
              <div class="icon">
                <i class="fa fa-arrows-alt-v"></i>
              </div>
              <div class="text">
                <strong>Remove vertical</strong>
                <p>Remove a vertical line</p>
              </div>
            </div>
          </li>
          <li>
            <div class="wrapper">
              <div class="icon">
                <i class="fa fa-arrows-alt-h"></i>
              </div>
              <div class="text">
                <strong>Remove horizontal</strong>
                <p>Remove a horizontal line</p>
              </div>
            </div>
          </li>
          <li>
            <div class="wrapper">
              <div class="icon">
                <i class="fa fa-arrows-alt"></i>
              </div>
              <div class="text">
                <strong>Remove up-down</strong>
                <p>Remove horizontal and vertical line</p>
              </div>
            </div>
          </li>
          <li>
            <div class="wrapper">
              <div class="icon">
                <i class="fa fa-hand-pointer"></i>
              </div>
              <div class="text">
                <strong>Taps +10'</strong>
                <p>Get 10 extra taps</p>
              </div>
            </div>
          </li>
        </ul>
      </p>
      <strong>Combos</strong>
      <p>Bigger combos equals bigger score and bigger bonuses</p>
      <strong>Combo progress</strong>
      <p>A full combo progress will add one point to your tap damage. Your progress is
        <strong>not</strong> reset after each level. </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'help',
  data() {
    return {};
  },
};
</script>

<style lang="less">
.help {
  padding: 2rem;
  height: 100%;
  flex-direction: column;

  h2 {
    margin-bottom: 2rem;
  }

  strong {
    font-size: 1.3rem;
  }
  p {
    margin: 0 0 2rem;
    font-size: 1.3rem;
  }

  .power-up-list {
    margin: 0;
    padding: 0;
    list-style-type: none;

    .wrapper {
      display: flex;
      align-items: center;
    }

    li {
      margin: 10px 0px;
    }

    .text {
      flex: 1;
      strong,
      p {
        font-size: 1rem;
        margin: 0;
      }
    }

    .icon {
      border: 2px solid #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
    }

  }

  .scores {
    overflow-x: hidden;
    overflow-y: auto;
    height: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// Help.vue?27d6f85a